var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlaystore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_1191)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.66964 0.877687C4.12289 0.52439 3.46617 0.417609 2.85019 0.563015L13.6751 11.388L17.1835 7.87959L4.66964 0.877687Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.50666 1.44287C1.20474 1.84426 1.03098 2.33711 1.03098 2.85845V22.1409C1.03098 22.6622 1.20479 23.155 1.50666 23.5564L12.5634 12.4997L1.50666 1.44287Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7622 10.4415L18.6091 8.67725L14.7867 12.4996L18.6093 16.3222L21.7627 14.5578C22.5182 14.1345 22.9692 13.3652 22.9692 12.4996C22.9692 11.634 22.5182 10.8648 21.7622 10.4415Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.675 13.6116L2.85074 24.4359C3.02821 24.4776 3.20882 24.5001 3.38943 24.5001C3.83577 24.5001 4.28057 24.3732 4.66958 24.1218L17.1836 17.12L13.675 13.6116Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_1191"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaystore);
export default __webpack_public_path__ + "static/media/playstore.d20bb0b619d75513380b8b731a052ecb.svg";
export { ForwardRef as ReactComponent };